import { create } from "zustand";
import { WS_HOST } from "../../api";
import { getCookie } from "../../utils";
import { SocketDispatcherMap, handleEvent, parseEvent } from "../../socket";
import useChatStore from "../chat-store";

interface State {
  socket: WebSocket | null;
  isOpen: boolean;

  queue: string[];
}

interface Action {
  connect: () => void;
  close: () => void;

  sockDispatch: <T extends keyof SocketDispatcherMap>(
    type: T,
    data: SocketDispatcherMap[T]
  ) => void;
}

const RETRY_INTERVAL = 5000;

let interval: NodeJS.Timer;

const useSocketStore = create<State & Action>((set, get) => ({
  socket: null,
  isOpen: false,
  queue: [],

  connect: () => {
    clearInterval(interval);

    let s = new WebSocket(`${WS_HOST}/${getCookie("token")}`);

    s.addEventListener("open", () => {
      console.log("connected!");

      let q = get().queue;
      while (q.length) {
        get().socket?.send(q[0]);
        q = q.filter((_, j) => j !== 0);
      }

      setTimeout(() => {
        useChatStore.getState().fetchChats(true);
      }, 1000);

      set({ isOpen: true, queue: [] });

      clearInterval(interval);
    });
    s.addEventListener("close", () => {
      console.log("disconnected!");

      set({ isOpen: false });

      clearInterval(interval);
      interval = setInterval(() => {
        console.log("trying to reconnect!");
        get().connect();
      }, RETRY_INTERVAL);
    });

    s.addEventListener("message", (event) => {
      const parsedEvent = JSON.parse(event.data);

      handleEvent(parseEvent(parsedEvent.event, parsedEvent.data));
    });

    set({ socket: s });
  },

  close: () => {
    get().socket?.close();

    setTimeout(() => {
      clearInterval(interval);
    }, 1000);
  },

  sockDispatch: (type, data) => {
    const sock = get().socket;
    const isOpen = get().isOpen;

    const jsonRes = JSON.stringify({ event: type, ...data });

    if (!sock || !isOpen) return get().queue.push(jsonRes);

    sock.send(jsonRes);
  },
}));

export default useSocketStore;
